// extracted by mini-css-extract-plugin
module.exports = {"btn":"forgotpassword_btn__2SFaz","inputContainer":"forgotpassword_inputContainer__3Cgnx","input":"forgotpassword_input__2-p-h","reset_otp":"forgotpassword_reset_otp__3-Bbd"};